import { StateCreator } from "zustand";

export type CommentFormSlice = {
  viewId: number | null;
  toggleId: (id: number) => void;
  deleteId: () => void;
};

// Comment Form 전역

export const createCommentFormSlice: StateCreator<CommentFormSlice> = (
  set
) => ({
  viewId: null,
  toggleId: (id) =>
    set((state) => ({
      viewId: state.viewId === id ? null : id,
    })),
  deleteId: () => set({ viewId: null }),
});
